export class LocalShipmentItem {

  public line: number;
  public productId: string;
  public productDescription: string;
  public weight: number;
  public pieces: number;

  static fromDto(i): LocalShipmentItem {
    const item = new LocalShipmentItem();

    if (!i) {
      return null;
    }

    item.line               = i.line;
    item.productId          = i.product_id;
    item.productDescription = i.product_description;
    item.weight             = i.weight;
    item.pieces             = i.pieces;

    return item;
  }

}
